export default __webpack_public_path__ + "static/How Sleep Boosts Immunity System Against Covid-19-5fce504903bb88d22a533b5f343943ca.jpg";